import React, { useEffect, useRef } from 'react';
import './headerI+D+I.scss';
import FondoHeader from '../../../media/img/i+d+i/header_idi.jpg';

const HeaderIDI = () => {
  const lineRefs = useRef([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px 0px 0px',
    };

    const lineObservers = lineRefs.current.map((lineRef) => {
      if (!lineRef) return null;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('content__title-line--visible');
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);
      observer.observe(lineRef);
      return observer;
    });

    return () => {
      lineObservers.forEach((obs) => obs?.disconnect());
    };
  }, []);

  return (
    <div>
      <div className="main-content__header">
        <div className="main-content__img-container">
          <img
            className="main-content__img idi-header__img"
            src={FondoHeader}
            alt="I+D+i Wonderaly"
          />
        </div>
        <div className="main-content__lineatop"></div>
        <div className="main-content__lineabottom"></div>
        <div className="main-content__text">
          <div>
            <h1 className="main-content__title">
              I+D+i EN WONDERALY INNOVATIONS
            </h1>
          </div>
          <div
            ref={(el) => (lineRefs.current[0] = el)}
            className="content__title-line"
          />
          <div>
            <p className="header-subtitle__main-page">
              Donde la neurociencia se convierte en innovación aplicada
            </p>
          </div>
          <div>
            <p className="header-text__main-page">
              En WONDERALY INNOVATIONS entendemos la I+D+i como un ecosistema
              científico donde convergen la neuropsicología aplicada, la
              Inteligencia Artificial y el Business Intelligence. Nuestro
              objetivo es claro: transformar el conocimiento del comportamiento
              humano en herramientas reales que optimicen la producción
              audiovisual y generen impacto social medible.
            </p>
          </div>
        </div>
        <div />
      </div>
    </div>
  );
};

export default HeaderIDI;
